var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-wrapper"},[_c('div',{staticClass:"side"},[_c('SideBar')],1),_c('div',{staticClass:"main-content"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }